"use strict";
exports.__esModule = true;
exports.CsvFormat = void 0;
var CsvFormat = /** @class */ (function () {
    function CsvFormat() {
    }
    CsvFormat.csvRowsToFile = function (rows) {
        return Buffer.from(rows.join(CsvFormat.CSV_ROW_SEPARATOR));
    };
    CsvFormat.csvFileToRows = function (file) {
        return file.toString().split(CsvFormat.CSV_ROW_SEPARATOR);
    };
    CsvFormat.csvColumnsToRow = function (columns, separator) {
        if (separator === void 0) { separator = CsvFormat.CSV_COLUMN_SEPARATOR; }
        return columns.join(separator);
    };
    CsvFormat.csvRowToColumns = function (row) {
        return row.split(CsvFormat.CSV_COLUMN_SEPARATOR);
    };
    CsvFormat.CSV_ROW_SEPARATOR = "\r\n";
    CsvFormat.CSV_COLUMN_SEPARATOR = ",";
    return CsvFormat;
}());
exports.CsvFormat = CsvFormat;
